const SpeakableSchema = (name = '', url = '', contentIdArray = []) =>
  // Example content array = ['#test1', '#test2']
  JSON.stringify({
    '@context': 'https://schema.org/',
    '@type': 'WebPage',
    name,
    speakable: {
      '@type': 'SpeakableSpecification',
      cssSelector: contentIdArray,
    },
    url,
  });

export default SpeakableSchema;
